<template>
  <div class="child-detail">
    <ChildModal :title="$store.state.childModalTitle">
      <div class="single-line youkelianggaikuang">
        <div class="chart-title"></div>
        <div class="chart-content">
          <YoukeliangGaikuang :rangeHeight="0.24" :chartData="YoukeliangGaikuangData" v-if="YoukeliangGaikuangData" />
        </div>
      </div>
      <div class="zhanwei"></div>
    </ChildModal>
  </div>
</template>

<script>
import ChildModal from '@/components/Common/ChildModal.vue'
import YoukeliangGaikuang from '@/components/Home/YoukeliangGaikuang.vue'

export default {
  name: 'YoukeliangGaikuangDetai',
  components: {
    ChildModal,
    YoukeliangGaikuang
  },
  props: {},
  data() {
    return {
      YoukeliangGaikuangData: null
    }
  },
  mounted() {
    // 请求游客量概况
    fetch('/data/Home/YoukeliangGaikuang.json')
      .then(response => {
        return response.json()
      })
      .then(json => {
        this.YoukeliangGaikuangData = json.data
      })
  },
  methods: {}
}
</script>

<style scoped lang="less">
.youkelianggaikuang {
  .chart-content {
    width: 80%;
  }
}
</style>
